// Banner superiore di errori/avvisi di validazione configurazione
import { motion, AnimatePresence } from 'framer-motion';
import { XCircle, AlertTriangle } from 'lucide-react';
import { FADE_IN_ANIMATION } from './constants';

export function ValidationBanner({ validation }) {
  return (
    <AnimatePresence>
      {(validation.warnings.length > 0 || validation.errors.length > 0) && (
        <motion.div
          {...FADE_IN_ANIMATION}
          data-testid="configurator-top-warning"
        >
          {validation.errors.length > 0 ? (
            <div className="flex items-start gap-3 p-4 rounded-xl border bg-rose-50 border-rose-200 text-rose-800 shadow-sm">
              <XCircle className="h-5 w-5 text-rose-500 mt-0.5 shrink-0" />
              <div className="flex-1">
                <p className="font-semibold">{validation.statusMessage}</p>
                <ul className="mt-1 text-sm space-y-1">
                  {validation.errors.map((e) => (
                    <li key={`err-${e.code || e.message}`}>{e.message}</li>
                  ))}
                </ul>
              </div>
            </div>
          ) : (
            <div className="flex items-start gap-3 p-4 rounded-xl border bg-amber-50 border-amber-200 text-amber-800 shadow-sm">
              <AlertTriangle className="h-5 w-5 text-amber-500 mt-0.5 shrink-0" />
              <div className="flex-1">
                <p className="font-semibold">{validation.statusMessage}</p>
                <ul className="mt-1 text-sm space-y-1">
                  {validation.warnings.map((w) => (
                    <li key={`warn-${w.code || w.message}`}>{w.message}</li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
